// SOK-09: modo accesible del tótem. Lógica sin React para poder probarla con Vitest; el estado vive
// en `A11yContext` (src/hooks/useA11y.js) y los estilos en `src/index.css` bajo `[data-a11y-*]`.

// Interruptores del panel. Los tiempos de espera no cambian con el modo: los de inactividad ya
// alcanzan y los del pago dependen del proveedor del terminal.
export const A11Y_FEATURES = ['contrast', 'text', 'low'];

export const A11Y_OFF = Object.freeze({ contrast: false, text: false, low: false });

// Fuera de la pantalla inicial el botón "Accesible" se esconde si no se toca en este tiempo y deja
// una pestaña en el borde; a la mitad del tiempo late para avisar que se va a esconder.
export const A11Y_FAB_HIDE_MS = 10 * 1000;
export const A11Y_FAB_PULSE_MS = A11Y_FAB_HIDE_MS / 2;

// Altura de la zona baja cuando la instancia no define `a11y.lowZonePx`: la pantalla baja un
// tercio y la app ocupa los dos tercios inferiores.
export const DEFAULT_LOW_ZONE = 'calc(100vh * 2 / 3)';
// Por debajo de esto el catálogo y los modales no caben; se ignora un valor menor.
export const MIN_LOW_ZONE_PX = 480;

export const isA11yActive = (settings) => A11Y_FEATURES.some((key) => Boolean(settings?.[key]));

export const toggleA11yFeature = (settings, key) => {
  if (!A11Y_FEATURES.includes(key)) return settings;
  return { ...settings, [key]: !settings[key] };
};

// Atributos que se ponen en <html>. `null` significa quitarlo.
export const getA11yAttributes = (settings) => ({
  'data-a11y': isA11yActive(settings) ? 'on' : null,
  'data-a11y-contrast': settings?.contrast ? 'high' : null,
  'data-a11y-text': settings?.text ? 'large' : null,
  'data-a11y-low': settings?.low ? 'on' : null,
});

// Valor CSS de la zona baja según la instancia (`instances/{id}.a11y.lowZonePx`), nunca más alto
// que la pantalla.
export const resolveLowZone = (instance) => {
  const px = Number(instance?.a11y?.lowZonePx);
  if (!Number.isFinite(px) || px < MIN_LOW_ZONE_PX) return DEFAULT_LOW_ZONE;
  return `min(${Math.round(px)}px, 100vh)`;
};

// Tamaño de letra que crece con "Letra grande". Úsalo en `style` en vez de 'NNpx'; en clases,
// `fs-NN` y `lh-NN` (definidas en index.css) hacen lo mismo.
export const fs = (px) => `calc(${px}px * var(--fs-scale, 1))`;
